import { createContext } from 'react';

interface AuthContextValues {
  getAuthToken: () => string | undefined;
  setAuthToken: (token: string) => void;
  getXToken: () => string | undefined;
  setXToken: (token: string) => void;
  authLoaded: boolean;
}

const AuthContext = createContext<AuthContextValues>({
  getAuthToken: () => undefined,
  setAuthToken: (_: string) => null,
  getXToken: () => undefined,
  setXToken: (_: string) => null,
  authLoaded: false,
});

export default AuthContext;
